import { autoinject, bindable } from "aurelia-framework";

@autoinject
export class ScopeListHover {
  @bindable IsDirtyExplanation: string;
}